import React, { memo, useState } from 'react';
import { Button, Spinner } from 'reactstrap';

const CustomButton = memo(({ handleSubmit, loading, label, disabled=false }) => {

    return (
        <Button color="primary" className="btn-sm btn-load" type="submit" onClick={handleSubmit} disabled={loading || disabled}>
            {loading ? <span className="d-flex align-items-center">
                <span className="flex-grow-1 me-2">
                    {label}
                </span>
                <Spinner size="sm" className="flex-shrink-0" role="status"> Loading... </Spinner>
            </span> : label}
        </Button>

    );
});

export default CustomButton;
